export const tipoPeriodoInitialState = {
  tiposPeriodos: [],
  novoTipoPeriodo: [],
  tipoPeriodoRemovido: [],
  tipoPeriodo: [],
  tipoPeriodoEditado: [],
  dropdownTiposPeriodos: [],
};
